import { makeStyles } from '@mui/styles';

export default makeStyles(theme => ({
    statusDate: {
        color: theme.palette.grey[500],
        fontSize: 12,
        marginLeft: 10,
        display: 'inline-block',
        minWidth: 30
    },
    tableCellMuted: {
        opacity: 0.55
    },
    tableCell: {
        borderColor: `${theme.palette.grey[300]}!important`
    },
    row: {
        cursor: 'pointer'
    }
}));
